// Booking status constants
export const BOOKING_STATUS = {
  PENDING: 'pending',
  ASSIGNED: 'assigned',
  EN_ROUTE: 'en_route',
  ON_SITE: 'on_site',
  IN_PROGRESS: 'in_progress',
  PAYMENT_PENDING: 'payment_pending',
  COMPLETED: 'completed',
  COMPLETE_WITHOUT_WORK: 'complete_without_work',
  CANCELLED: 'cancelled',
};

// Booking urgency constants
export const URGENCY = {
  EMERGENCY: 'emergency',
  HOURS_24: '24h',
  HOURS_48: '48h',
};

// Quote feature decommissioned - removed QUOTE_STATUS constants

// User roles
export const ROLES = {
  CUSTOMER: 'customer',
  TECHNICIAN: 'technician',
  ADMIN: 'admin',
};

// Service categories
export const SERVICE_CATEGORIES = {
  PLUMBING: 'plumbing',
  ELECTRICAL: 'electrical',
  HVAC: 'hvac',
  CARPENTRY: 'carpentry',
  PAINTING: 'painting',
  CLEANING: 'cleaning',
  APPLIANCE_REPAIR: 'appliance_repair',
  LOCKSMITH: 'locksmith',
  PEST_CONTROL: 'pest_control',
  MOVING: 'moving',
  OTHER: 'other',
};


